
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemeMasterGrid extends Serenity.EntityGrid<SchemeMasterRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemeMaster'; }
        protected getDialogType() { return SchemeMasterDialog; }
        protected getIdProperty() { return SchemeMasterRow.idProperty; }
        protected getInsertPermission() { return SchemeMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SchemeMasterRow.localTextPrefix; }
        protected getService() { return SchemeMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }



    }
}